import { lazy } from 'solid-js'
import { messages } from '../../pages/demo-page/demo-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/demo-page/demo-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/demo',
    titleMessage: messages.titleMessage,
}
